// extracted by mini-css-extract-plugin
module.exports = {"FilterForm__hgroup":"fr_a pz_a pz_x","FilterForm__vgroup":"fr_b pz_oi"};